module.exports = __webpack_public_path__ + "img/bush.62fa229d.webp";